<template>
    <div class="news-messages">
        <a v-for="newsMessage in newsMessages" :href="newsMessage.detail_uri" class="py-4 d-block">
            <div class="mb-2">
                <h3 class="mb-0">{{ newsMessage.title }}</h3>
                <span class="text-muted">{{ $dayjs(newsMessage.publish_at).format('DD/MM/YYYY') }}</span>
            </div>
            <div class="d-flex align-items-start flex-column flex-md-row">
                <img v-if="newsMessage.thumbnail" :src="newsMessage.thumbnail" class="mb-3 mb-md-0 me-md-3 d-none d-md-inline-block">
                <img v-if="newsMessage.mobile_thumbnail" :src="newsMessage.mobile_thumbnail" class="mb-3 d-inline-block d-md-none" style="width: 250px">
                <div>
                    <p v-if="newsMessage.intro" v-html="newsMessage.intro"></p>
                    <span class="read-more">{{ __('Read more') }} <i class="fa fa-chevron-right"></i></span>
                </div>
            </div>
        </a>
        <div v-if="lastPage && lastPage > page" class="text-center mt-3">
            <observer @on-change="loadMoreButtonChange">
                <button class="btn btn-primary text-white" @click.prevent="loadNewsMessages(page+1)">{{ __('Load more results') }}</button>
            </observer>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                newsMessages : [],
                page : 1,
                lastPage : null,
            }
        },
        methods: {
            loadNewsMessages(page) {
                this.loading = true;
                axios.get(location.href, { params : { ajax: true, page: page }})
                     .then(response => {
                        this.newsMessages = this.newsMessages.concat(response.data.data);
                        this.loading = false;
                        this.page = response.data.current_page;

                        this.lastPage = response.data.last_page;
                     });
            },
            loadMoreButtonChange(entry) {
                if (entry.isIntersecting) {
                    this.loadNewsMessages(this.page+1);
                }
            },
        },
        mounted() {
            this.loadNewsMessages();
        },
    }
</script>
